import { render, staticRenderFns } from "./clientOverview_EditActivityDetails.vue?vue&type=template&id=6ecd4a5d&scoped=true&"
import script from "./clientOverview_EditActivityDetails.vue?vue&type=script&lang=js&"
export * from "./clientOverview_EditActivityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd4a5d",
  null
  
)

export default component.exports